import styled from 'styled-components'

import { InfoMessage } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

export type CommentsHistoryErrorProps = {
  onRetry?: () => void
} & ClassNameProps

export const CommentsHistoryError = ({
  onRetry,
  className,
}: CommentsHistoryErrorProps) => (
  <Root className={className}>
    <InfoMessage intent="error" variant="dt" withBackground onRetry={onRetry} />
  </Root>
)

const Root = styled.div`
  display: grid;
`
